import(/* webpackMode: "eager", webpackExports: ["TimeZoneChangeDetector"] */ "/app/code/build/apps/web/src/app/[locale]/timezone-change-detector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/code/build/apps/web/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/code/build/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/code/build/node_modules/tailwindcss/tailwind.css");
;
import(/* webpackMode: "eager" */ "/app/code/build/apps/web/src/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/code/build/packages/ui/src/toaster.tsx");
